import { AutogenModelPayeeForWireFunds, AutogenRowPayeeForWireFunds } from "./autogen/AutogenModelPayeeForWireFunds";

export class ModelPayeeForWireFunds extends AutogenModelPayeeForWireFunds<RowPayeeForWireFunds> {
	constructor() {
		super(RowPayeeForWireFunds);
	}
}

export class RowPayeeForWireFunds extends AutogenRowPayeeForWireFunds {
}